export const BULK_EDIT_DEFAULT_DAYS = [1, 2, 3, 4, 5, 6, 7];

export const DAYS_OPTIONS = [
  { label: 'Mon', value: 1, fullName: 'Monday' },
  { label: 'Tue', value: 2, fullName: 'Tuesday' },
  { label: 'Wed', value: 3, fullName: 'Wednesday' },
  { label: 'Thu', value: 4, fullName: 'Thursday' },
  { label: 'Fri', value: 5, fullName: 'Friday' },
  { label: 'Sat', value: 6, fullName: 'Saturday' },
  { label: 'Sun', value: 7, fullName: 'Sunday' },
];

export const DATE_FORMATS = {
  DATE_PICKER_DAY: 'ddd DD MMM',
} as const;
